import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { siteMembersApi } from '../utils/api'

export function JoinPage() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const [status, setStatus] = useState<'loading' | 'success' | 'error' | 'unauthed'>('loading')
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    const isAuthed = localStorage.getItem('bst-auth') === 'true'
    if (!isAuthed) {
      setStatus('unauthed')
      return
    }
    if (!token) {
      setStatus('error')
      setErrorMsg('Неверная ссылка приглашения')
      return
    }
    siteMembersApi.acceptInvite(token)
      .then(member => {
        setStatus('success')
        localStorage.setItem('bst-site-id', member.siteId)
        setTimeout(() => navigate('/editor', { replace: true }), 1500)
      })
      .catch(err => {
        setStatus('error')
        setErrorMsg(err instanceof Error ? err.message : 'Ошибка активации приглашения')
      })
  }, [token, navigate])

  const containerStyle: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0f172a',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  }

  const cardStyle: React.CSSProperties = {
    background: '#1e293b',
    border: '1px solid #334155',
    borderRadius: '16px',
    padding: '48px',
    textAlign: 'center',
    maxWidth: '420px',
    width: '100%',
    margin: '24px',
  }

  if (status === 'unauthed') {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔐</div>
          <h2 style={{ color: '#f1f5f9', fontWeight: 700, fontSize: '22px', margin: '0 0 12px' }}>Войдите в аккаунт</h2>
          <p style={{ color: '#94a3b8', margin: '0 0 24px', lineHeight: 1.6 }}>
            Чтобы принять приглашение, сначала войдите в BST или создайте аккаунт.
          </p>
          <button
            onClick={() => navigate(`/login?next=/join/${token}`, { replace: true })}
            style={{ padding: '12px 28px', background: '#5b6af0', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: 700, cursor: 'pointer', width: '100%' }}
          >
            Войти / Зарегистрироваться
          </button>
        </div>
      </div>
    )
  }

  if (status === 'loading') {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
          <h2 style={{ color: '#f1f5f9', fontWeight: 700, fontSize: '22px', margin: 0 }}>Принимаю приглашение...</h2>
        </div>
      </div>
    )
  }

  if (status === 'success') {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎉</div>
          <h2 style={{ color: '#10b981', fontWeight: 700, fontSize: '22px', margin: '0 0 12px' }}>Добро пожаловать!</h2>
          <p style={{ color: '#94a3b8', margin: 0, lineHeight: 1.6 }}>
            Приглашение принято. Открываю редактор...
          </p>
        </div>
      </div>
    )
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
        <h2 style={{ color: '#ef4444', fontWeight: 700, fontSize: '22px', margin: '0 0 12px' }}>Ошибка</h2>
        <p style={{ color: '#94a3b8', margin: '0 0 24px', lineHeight: 1.6 }}>{errorMsg}</p>
        <button
          onClick={() => navigate('/dashboard', { replace: true })}
          style={{ padding: '10px 24px', background: '#5b6af0', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}
        >
          На главную
        </button>
      </div>
    </div>
  )
}
